import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "VolumenMin",
  "use": "VolumenMin-usage",
  "viewBox": "0 0 49 62",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 49 62\" id=\"VolumenMin\"><path d=\"M12 20.667H0v20.666h12L36 62V0L12 20.667zM41 21l5-3c2 3.993 3 8.187 3 12.58 0 4.395-1 8.868-3 13.42l-5-3c1.333-2.674 2-6.147 2-10.42 0-4.272-.667-7.466-2-9.58z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol